import React, { useCallback, useEffect, useState } from 'react'
import { X, Plus } from 'react-bootstrap-icons'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'
import HourSelector from '../../hours/selector'
import DurationSelector from '../../durations/selector'
import { Col, Row, Button, ButtonGroup, InputGroup } from 'react-bootstrap'

const OccurrenceEditor = ({
    value = {},
    onChange = () => {},
    onDelete = () => {},
    onAdd = () => {},
    removable,
    buttonsVisible,
    disabled
}) => {
    const [pickerVisible, setVisible] = useState(false)

    useEffect(() => {
        if(value && !value.date) {
            onChange({...value, date: new Date()})
        }
    }, [value, onChange])
    const onDateChange = useCallback(momentDate => {
        onChange({ ...value, date: momentDate.toDate() })
    }, [value, onChange])

    return (
        <Row>
            <Col sm={4}>
                <SingleDatePicker
                    date={moment(value.date)}
                    onDateChange={date => onDateChange(date)}
                    focused={pickerVisible}
                    onFocusChange={({ focused }) => setVisible(focused)}
                    numberOfMonths={1}
                    hideKeyboardShortcutsPanel
                    regular
                    disabled={Boolean(disabled)}
                />
            </Col>
            <Col sm={4}>
                <HourSelector
                    value={value.hourId}
                    onChange={hourId => onChange({ ...value, hourId })}
                    disabled={disabled}
                />
            </Col>
            <Col sm={4}>
                <InputGroup>
                    <DurationSelector
                        value={value.durationId}
                        onChange={durationId => onChange({ ...value, durationId })}
                        disabled={disabled}
                    />
                    {buttonsVisible &&
                    <InputGroup.Append>
                        <Button onClick={() => onAdd()} variant='outline-success'><Plus /></Button>
                        <Button onClick={() => onDelete()} variant='outline-danger' disabled={!removable}><X /></Button>
                    </InputGroup.Append>
                    }
                </InputGroup>
            </Col>
        </Row>
    )
}

export default OccurrenceEditor

